import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=dd2c21a0&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=dd2c21a0&prod&lang=scss&scoped=true"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=dd2c21a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2c21a0",
  null
  
)

export default component.exports